import script from "./RecordFieldSummary.vue?vue&type=script&setup=true&lang=js"
export * from "./RecordFieldSummary.vue?vue&type=script&setup=true&lang=js"

import "./RecordFieldSummary.vue?vue&type=style&index=0&id=8c20c28c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8c20c28c"]])

export default __exports__